import { Button, Stack } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import type { ChildProcessWithoutNullStreams } from 'child_process'
import clsx from 'clsx'
import { Dayjs } from 'dayjs'
import { DateFns } from 'lang-utils'
import React from 'react'
import { classToFComponent, FCClassContext } from 'src/utils/views'
import { makeStyles } from 'tss-react/mui'
import { Logger } from 'wdc-cube'
import { ProfileFilterScope } from '../../up_scopes'
import ProfileCard from './profile-card'

const LOG = Logger.get('UserProfile-Filters')

const fns = DateFns.singleton

const useStyles = makeStyles()({
    button: {
        height: '53px'
    }
})
export type UserProfileFiltersProps = {
    className?: string
    style?: React.CSSProperties
    key?: string
    filterScope: ProfileFilterScope
}

class UserProfileFiltersClass implements FCClassContext<UserProfileFiltersProps> {
    classes!: ReturnType<typeof useStyles>['classes']
    filterScope!: ProfileFilterScope

    onSyncState({ filterScope }: UserProfileFiltersProps) {
        this.classes = useStyles().classes
        this.filterScope = filterScope
    }

    readonly emitFind = () => {
        const startMonth = fns().formatDate(this.filterScope.startMonth?.toISOString(), 'yyyy-MM-dd')
        const endMonth = this.filterScope.endMonth
            ? fns().formatDate(this.filterScope.endMonth.toISOString(), 'yyyy-MM-dd')
            : undefined
        this.filterScope.onFind({ startMonth, endMonth }).catch(LOG.caught)
    }

    readonly handleStartMonthChange = (newVal: unknown | ChildProcessWithoutNullStreams) => {
        const dayJsVal = newVal as Dayjs
        this.filterScope.startMonth = dayJsVal
    }

    readonly handleEndMonthChange = (newVal: unknown | ChildProcessWithoutNullStreams) => {
        const dayJsVal = newVal as Dayjs
        this.filterScope.endMonth = dayJsVal
    }

    render({ className }: UserProfileFiltersProps) {
        return (
            <ProfileCard className={clsx(className)}>
                <Stack direction="row" spacing={2}>
                    <DatePicker
                        label="Mês inicial"
                        views={['month', 'year']}
                        formatDensity="dense"
                        value={this.filterScope.startMonth}
                        onChange={this.handleStartMonthChange}
                    />

                    <DatePicker
                        label="Mês final"
                        views={['month', 'year']}
                        formatDensity="dense"
                        value={this.filterScope.endMonth}
                        onChange={this.handleEndMonthChange}
                    />

                    <Button variant="outlined" size="large" className={this.classes.button} onClick={this.emitFind}>
                        Buscar
                    </Button>
                </Stack>
            </ProfileCard>
        )
    }
}
export const UserProfileFilters = classToFComponent(UserProfileFiltersClass, React)
export default UserProfileFilters
